import { getParentWindow } from './context/DatabaseContentContext.tsx';

// TODO: refactor to consolidate into app-mode.ts
const getParentProduct = (): string | undefined => {
  const parentQueryParams = new URLSearchParams(getParentWindow().location.search);
  const selfQueryParams = new URLSearchParams(window.location.search);

  if (parentQueryParams.has('parentProduct')) {
    return parentQueryParams.get('parentProduct') ?? undefined;
  }

  if (selfQueryParams.has('parentProduct')) {
    return selfQueryParams.get('parentProduct') ?? undefined;
  }

  return undefined;
};

// If parent product is rovo, it means that we are viewing the DB in the AIFC staging area
export const isAIFCStagingAreaView = () => getParentProduct() === 'rovo';
